// extracted by mini-css-extract-plugin
export default {"drawer":"xtfdRT63braD5s6H1XGhxA=="};